import React, { useState, useContext, useEffect } from "react";
import Nav from 'react-bootstrap/Nav';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import './navigationBar.scss';
import burgerIcon from '../../assets/navbar/burgerMenu.svg';
import crossIcon from '../../assets/navbar/crossIcon.svg';
import logoWithoutText from '../../assets/logo_without_text.png';
import { translateText } from '../../services/deeplTranslationService';
import { LanguageContext } from '../../services/LanguageContext';

const NavigationBar = () => {
  const { lang } = useParams(); // Get 'lang' from the URL
  const navigate = useNavigate(); // For navigation
  const { language, changeLanguage } = useContext(LanguageContext); // Get language from context
  const [expanded, setExpanded] = useState(false);
  const [translatedTexts, setTranslatedTexts] = useState({
    startseite: 'Startseite',
    ueberUns: 'Über uns',
    faq: 'FAQ',
    kostenlosStarten: 'Kostenlos starten',
  });

  const handleToggle = () => setExpanded(!expanded);

  // Update translations when language changes
  useEffect(() => {
    const updateTranslations = async () => {
      // Only translate if language is not German
      if (language !== 'DE') {
        const startseite = await translateText('Startseite', language);
        const ueberUns = await translateText('Über uns', language);
        const faq = await translateText('FAQ', language);
        const kostenlosStarten = await translateText('Kostenlos starten', language);

        setTranslatedTexts({
          startseite,
          ueberUns,
          faq,
          kostenlosStarten,
        });
      }
    };

    updateTranslations();
  }, [language, lang]);

  // Update language context and navigate to new language route
  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value.toLowerCase();
    changeLanguage(newLanguage);
    navigate(`/${newLanguage}`);
  };

  return (
    <>
      <Navbar expanded={expanded} className="custom-navbar shadow" expand="lg" fixed="top">
        <div className="container">
          <Navbar.Brand className={`${expanded ? 'isOpen' : ''}`}>
            <a href={`/${lang}`}>
              <img src={logoWithoutText} alt="logo" height={40} className="logo-desktop" />
              <img src={logoWithoutText} alt="logo" height={50} className="logo-mobile" />
            </a>
          </Navbar.Brand>
          <Nav className="Kostenlos-starten-container">
            <Nav.Link className={`Kostenlos-starten ${expanded ? 'isOpen' : ''}`} href={`/${lang}/Anmeldung`}>
              {translatedTexts.kostenlosStarten}
            </Nav.Link>
          </Nav>
          <Navbar.Toggle
            style={{ paddingRight: '0' }}
            aria-controls="basic-navbar-nav"
            onClick={handleToggle}
            className="custom-toggler"
          >
            <img src={expanded ? crossIcon : burgerIcon} alt="menu icon" />
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center nav-menu-container">
            <div className="nav-menu-divider"></div>
            <Nav className="mx-auto navbar-items">
              <Nav.Link href={`/${lang}/`}>{translatedTexts.startseite}</Nav.Link>
              <Nav.Link href={`/${lang}/about`}>{translatedTexts.ueberUns}</Nav.Link>
              <Nav.Link href={`/${lang}/faq`}>{translatedTexts.faq}</Nav.Link>
            </Nav>

            <div className="language-select-container">
              <select onChange={handleLanguageChange} value={language.toLowerCase()} className="form-control">
                <option value="de">De</option>
                <option value="en">En</option>
              </select>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>

    </>
  );
};

export default NavigationBar;
